import type { enLanders } from "./en.landers";

/** Russian for the landers (see `en.landers.ts`). Words from the boards LanderList … LanderEmpty. */
export const ruLanders: Record<keyof typeof enLanders, string> = {
  "landers.title": "Ленды",
  "landers.subtitle": "Страницы, которые человек видит до оффера и после заявки. Цифры — за период сверху.",
  "landers.new": "Новый ленд",
  "landers.layout": "Вид списка",
  "landers.layout.table": "Таблица",
  "landers.layout.tiles": "Плитки",
  "landers.loadFailed": "Не удалось загрузить ленды",
  "landers.notFound": "Ленд не найден",
  "landers.back": "К лендам",
  "landers.tabs": "Разделы ленда",
  "landers.tab.preview": "Просмотр",
  "landers.tab.numbers": "Цифры",
  "landers.tab.versions": "Версии",
  "landers.tab.settings": "Настройки",
  "landers.tab.usage": "Где используется",
  "landers.search": "Название, id, адрес",
  "landers.search.label": "Поиск лендов",
  "landers.search.clear": "Очистить поиск",
  "landers.count": "{n} {landers}",
  "landers.word.landers": "ленд|ленда|лендов",
  "landers.word.campaigns": "кампания|кампании|кампаний",
  "landers.word.campaignsIn": "кампании|кампаниях|кампаниях",
  "landers.sortedBy": "сортировка: {by}",
  "landers.sort.name": "название",
  "landers.sort.risk": "риск",
  "landers.sort.updated": "изменён",
  "landers.inCampaigns": "в {n} {campaigns}",
  "landers.unused": "не используется",
  "landers.noVersion": "нет версии",
  "landers.changed": "изменён {at}",
  "landers.col.name": "Название",
  "landers.col.type": "Тип",
  "landers.col.lang": "Язык",
  "landers.col.countries": "Страны",
  "landers.col.version": "Версия",
  "landers.col.visits": "Визиты",
  "landers.col.lpCtr": "LP CTR",
  "landers.col.leads": "Конв.",
  "landers.col.campaigns": "Кампании",
  "landers.col.risk": "Риск",
  "landers.col.updated": "Изменён",
  "landers.page.prev": "Назад",
  "landers.page.next": "Дальше",
  "landers.page.summary": "{from}–{to} из {total}",
  "landers.page.of": "Страница {page} из {pages}",
  "landers.page.perPage": "на странице",
  "landers.filtered.title": "Нет лендов под эти фильтры",
  "landers.filtered.body": "Уберите фильтр или поищите иначе.",
  "landers.filtered.reset": "Сбросить фильтры",
  "landers.facet.type": "Тип",
  "landers.facet.lang": "Язык",
  "landers.facet.country": "Страна",
  "landers.facet.risk": "Риск",
  "landers.facet.used": "Используется",
  "landers.facet.used.yes": "да",
  "landers.facet.used.no": "нет",
  "landers.filter.active": "Фильтры списка",
  "landers.filter.remove": "Убрать фильтр «{name}»",
  "landers.filter.edit": "Изменить фильтр «{name}»",
  "landers.filter.any": "Все",
  "landers.filter.add": "Фильтр",
  "landers.filter.facets": "По чему отобрать",
  "landers.filter.search": "Найти: {name}",
  "landers.filter.apply": "Применить",
  "landers.filter.reset": "Сбросить",
  "landers.filter.nothing": "Ничего не нашлось",
  "landers.filter.loading": "Загружаем…",
  "landers.filter.back": "Назад",
  "landers.type.landing": "Ленд",
  "landers.type.prelanding": "Преленд",
  "landers.type.vsl": "VSL",
  "landers.type.white": "Белая страница",
  "landers.type.whiteShort": "Белая",
  "landers.type.thanks": "Спасибо",
  "landers.type.default": "по умолчанию",
  "landers.risk.safe": "Безопасно",
  "landers.risk.warn": "Проверить",
  "landers.risk.danger": "Опасно",
  "landers.kpi.landers": "Ленды",
  "landers.kpi.inCampaigns": "в кампаниях {n}",
  "landers.kpi.visits": "Визиты",
  "landers.kpi.people": "люди {n}",
  "landers.kpi.wentOn": "Пошли дальше",
  "landers.kpi.wentOn.note": "на оффер или следующий шаг",
  "landers.kpi.lpCtr": "LP CTR",
  "landers.kpi.leads": "Конверсии",
  "landers.kpi.cr": "CR {cr}",
  "landers.kpi.risky": "С пометкой риска",
  "landers.kpi.dangerLive": "{n} опасный в работе",
  "landers.kpi.dangerNone": "опасных в работе нет",
  "landers.empty.title": "Пока нет ни одного ленда",
  "landers.empty.body": "Ленд — страница, которую человек видит между рекламой и оффером. Загрузите архив, укажите ссылку на готовую страницу или возьмите ленд из студии.",
  "landers.empty.studio": "Взять из студии",
  "landers.empty.kinds": "Какие бывают страницы",
  "landers.empty.about.prelanding": "История перед оффером: интервью, новость, отзыв. Разогревает и ведёт дальше.",
  "landers.empty.about.landing": "Страница оффера с формой заявки или кнопкой на партнёрку.",
  "landers.empty.about.vsl": "Видео-продажа: человек смотрит ролик, потом видит кнопку.",
  "landers.empty.about.white": "Её видят модераторы и боты вместо настоящего ленда.",
  "landers.empty.about.thanks": "После заявки: подтверждение и пиксель конверсии.",
  "landers.create.title": "Новый ленд",
  "landers.create.description": "Страница, которую увидит человек до оффера или после заявки. Ссылки и макросы проверим после загрузки.",
  "landers.create.close": "Закрыть",
  "landers.create.from": "Откуда взять страницу",
  "landers.create.zip": "Загрузить ZIP",
  "landers.create.zip.body": "архив с index.html, до 50 МБ",
  "landers.create.link": "По ссылке",
  "landers.create.link.body": "страница уже живёт на своём адресе",
  "landers.create.studio": "Из студии",
  "landers.create.studio.body": "готовый ленд из студии лендингов",
  "landers.create.studio.how": "Ленд из студии публикуется в трекер из самой студии: откройте ленд там и нажмите «Опубликовать в трекер» — он появится здесь со своими версиями.",
  "landers.create.studio.open": "Открыть студию",
  "landers.create.studio.foot": "Ленд придёт из студии сам",
  "landers.create.drop": "Перетащите ZIP сюда или выберите файл",
  "landers.create.dropHere": "Отпустите архив",
  "landers.create.dropRules": "до 50 МБ · index.html в корне архива",
  "landers.create.zipOnly": "Нужен архив .zip",
  "landers.create.tooBig": "Архив больше 50 МБ",
  "landers.create.needZip": "Выберите архив",
  "landers.create.removeZip": "Убрать архив",
  "landers.create.size": "{size} МБ",
  "landers.create.progress": "{loaded} из {total} МБ · {pct}%",
  "landers.create.url": "Адрес страницы",
  "landers.create.url.hint": "Заберём страницу с картинками и стилями; что не удастся взять, останется ссылкой на исходный сайт.",
  "landers.create.nameFromZip": "Подставили из имени архива — можно поменять.",
  "landers.create.nameFromLink": "Подставили из адреса — можно поменять.",
  "landers.create.namePlaceholder": "pl-joints-andrzej-kowalski",
  "landers.create.after": "После загрузки проверим: есть ли index.html, сколько кнопок ведут дальше, какие макросы стоят. Результат — на вкладке «Просмотр».",
  "landers.create.zipFoot": "Создадим, когда архив догрузится",
  "landers.create.linkFoot": "Создадим, когда страница будет взята",
  "landers.create.working": "Создаём…",
  "landers.create.cancel": "Отмена",
  "landers.create.submit": "Создать ленд",
  "landers.create.firstNote": "Первая загрузка",
  "landers.create.fromLink": "Взята по ссылке",
  "landers.create.skipped": "{n} файлов не удалось взять — они остались ссылками на исходный сайт",
  "landers.create.done": "Ленд «{name}» создан",
  "landers.create.failed": "Не удалось создать ленд",
  "landers.create.pageFailed": "Ленд создан, но страница не загрузилась: {error}. Загрузите её во «Версиях».",
  "landers.f.name": "Название",
  "landers.f.type": "Тип",
  "landers.f.language": "Язык",
  "landers.f.language.none": "не указан",
  "landers.f.countries": "Страны",
  "landers.f.countries.add": "Добавить страну…",
  "landers.f.risk": "Риск для модерации",
  "landers.err.name": "Нужно название",
  "landers.err.nameLong": "Не длиннее 200 знаков",
  "landers.err.url": "Нужен адрес вида https://…",
  "landers.err.ctas": "От 1 до 20 кнопок",
  "landers.head.version": "версия",
  "landers.head.from": "от {at}",
  "landers.head.noVersion": "страница ещё не загружена",
  "landers.head.author": "автор {name}",
  "landers.head.open": "Открыть на домене",
  "landers.head.noDomain": "У ленда нет домена — открыли внутри трекера",
  "landers.head.openFailed": "Не удалось открыть ленд",
  "landers.head.duplicate": "Дублировать",
  "landers.head.copyName": "{name} (копия)",
  "landers.head.testName": "{name} (тест)",
  "landers.head.copied": "Создана копия «{name}»",
  "landers.head.copyFailed": "Не удалось создать копию",
  "landers.head.more": "Ещё",
  "landers.head.download": "Скачать текущую версию",
  "landers.head.archive": "В архив",
  "landers.archive.title": "Убрать «{name}» в архив?",
  "landers.archive.body": "Ленд пропадёт из списка; его цифры останутся в отчётах.",
  "landers.archive.live": "Его показывают {n} {campaigns} — в архиве он не уйдёт из их ротации сам, уберите его в редакторе кампаний.",
  "landers.archive.confirm": "В архив",
  "landers.archive.done": "«{name}» в архиве",
  "landers.archive.failed": "Не удалось убрать в архив",
  "landers.n.visits": "Визиты",
  "landers.n.bots": "боты {pct} отсеяны",
  "landers.n.people": "Люди",
  "landers.n.leads": "Лиды",
  "landers.n.approved": "Апрувы",
  "landers.n.approve": "апрув {pct}",
  "landers.n.epc": "Доход на визит",
  "landers.n.chart.day": "Люди, переходы и лиды по дням",
  "landers.n.chart.hour": "Люди, переходы и лиды по часам",
  "landers.n.leadsAxis": "лиды, правая шкала",
  "landers.n.grain": "Шаг графика",
  "landers.n.grain.day": "День",
  "landers.n.grain.hour": "Час",
  "landers.n.noTraffic": "За период трафика через ленд не было",
  "landers.n.running": "идёт",
  "landers.n.byCampaign": "По кампаниям",
  "landers.n.shareNote": "доля ленда в ротации кампании",
  "landers.n.byCountry": "По странам",
  "landers.n.openReport": "Открыть в отчёте",
  "landers.n.col.campaign": "Кампания",
  "landers.n.col.share": "Доля",
  "landers.n.col.cr": "CR",
  "landers.n.col.revenue": "Доход",
  "landers.n.col.country": "Страна",
  "landers.n.noCountry": "страна не определена",
  "landers.n.total": "Итого",
  "landers.v.title": "Версии",
  "landers.v.compareHint": "выделены сравниваемые",
  "landers.v.drop": "Перетащите ZIP новой версии",
  "landers.v.dropRules": "до 50 МБ · index.html в корне архива · станет v{v}, текущей не станет сама",
  "landers.v.dropFirst": "до 50 МБ · index.html в корне архива · станет v{v} и сразу показывается",
  "landers.v.choose": "Выбрать файл",
  "landers.v.none": "Версий пока нет — загрузите ZIP.",
  "landers.v.noNote": "без описания",
  "landers.v.noteSave": "Сохранить описание",
  "landers.v.noteFailed": "Не удалось сохранить описание",
  "landers.v.files": "{n} файлов",
  "landers.v.failed": "не собралась",
  "landers.v.served": "Показывается",
  "landers.v.promote": "Сделать текущей",
  "landers.v.promoted": "v{v} теперь показывается",
  "landers.v.promoteFailed": "Не удалось сделать текущей",
  "landers.v.download": "Скачать v{v}",
  "landers.v.downloadFailed": "Не удалось скачать",
  "landers.v.uploaded": "Загружена v{v}",
  "landers.v.uploadFailed": "Не удалось загрузить архив",
  "landers.v.compare": "Сравнение",
  "landers.v.compareFrom": "Какую версию сравнить",
  "landers.v.compareTo": "С какой версией",
  "landers.v.currentLabel": "v{v} · текущая",
  "landers.v.filesChanged": "{n} файла",
  "landers.v.mode": "Как показать изменения",
  "landers.v.mode.inline": "Построчно",
  "landers.v.mode.side": "Рядом",
  "landers.v.compareNone": "Нужны две версии, чтобы сравнить.",
  "landers.v.diffFailed": "Не удалось сравнить версии",
  "landers.v.same": "Версии одинаковые.",
  "landers.v.change.added": "новый",
  "landers.v.change.removed": "удалён",
  "landers.v.change.modified": "изменён",
  "landers.v.change.replaced": "заменён",
  "landers.v.lines": "строки {ranges}",
  "landers.v.binary": "Файл не текстовый — сравниваем картинкой ниже.",
  "landers.v.tooLarge": "Файл слишком большой, чтобы сравнить построчно.",
  "landers.v.pictures": "Картинки сравниваются рядом: {path} v{from} · v{to}",
  "landers.s.main": "Основное",
  "landers.s.main.hint": "Название видят только в трекере.",
  "landers.s.type": "Тип страницы",
  "landers.s.type.hint": "От типа зависит, где его можно поставить в потоке кампании.",
  "landers.s.risk.safe": "можно показывать всем",
  "landers.s.risk.warn": "есть спорные обещания или фото до/после",
  "landers.s.risk.danger": "только людям, ботам и модераторам — белая страница",
  "landers.s.audience": "Аудитория",
  "landers.s.audience.hint": "Подсказка в редакторе кампании: какие страны и язык.",
  "landers.s.language": "Язык страницы",
  "landers.s.after": "После заявки",
  "landers.s.after.hint": "Какую страницу «Спасибо» увидит человек.",
  "landers.s.after.thanks": "Эта страница сама — «Спасибо».",
  "landers.s.after.where": "«Спасибо» выбирается в кампании; если там не выбрано — своя thankyou.html ленда, иначе «Спасибо» по умолчанию для языка {lang}.",
  "landers.s.default": "По умолчанию для своего языка",
  "landers.s.default.hint": "Её покажут после заявки во всех кампаниях без своей «Спасибо», где язык ленда — {lang}.",
  "landers.s.tracking": "Трекинг",
  "landers.s.tracking.hint": "Как трекер видит кнопки на странице.",
  "landers.s.ctas": "Кнопок на странице",
  "landers.s.domain": "Домен",
  "landers.s.clickUrl": "Ссылка для кнопок",
  "landers.s.clickUrl.hint": "Вставьте в href каждой кнопки; в архиве — макрос {click_url}.",
  "landers.s.script": "Скрипт трекера",
  "landers.s.script.hint": "Для страницы вне трекера; в загруженный архив вставлять не нужно.",
  "landers.s.copy": "Скопировать: {what}",
  "landers.s.copied": "Скопировано",
  "landers.s.copyFailed": "Не удалось скопировать",
  "landers.s.notes": "Заметки и теги",
  "landers.s.notes.hint": "Для себя: откуда взят, что тестируем.",
  "landers.s.notes.ph": "Взят у партнёрки DrCash 07.10, переведён…",
  "landers.s.tags": "Теги",
  "landers.s.tags.add": "Тег…",
  "landers.s.tags.none": "тегов нет",
  "landers.s.changed": "Изменено: {what}",
  "landers.s.changed.name": "название",
  "landers.s.changed.type": "тип",
  "landers.s.changed.risk": "риск",
  "landers.s.changed.countries": "страны",
  "landers.s.changed.language": "язык",
  "landers.s.changed.tracking": "трекинг",
  "landers.s.changed.notes": "заметки",
  "landers.s.changed.tags": "теги",
  "landers.s.seenBy": "изменения видят сразу все {n} {campaigns}",
  "landers.s.save": "Сохранить",
  "landers.s.discard": "Отменить",
  "landers.s.saved": "Настройки сохранены",
  "landers.s.saveFailed": "Не удалось сохранить",
  "landers.u.alert": "Новую версию видят сразу все {n} {campaigns}",
  "landers.u.alert.body": "Чтобы проверить изменение на части трафика, дублируйте ленд и поставьте копию рядом в ротации одной кампании.",
  "landers.u.duplicate": "Дублировать для теста",
  "landers.u.campaigns": "Кампании",
  "landers.u.campaigns.note": "цифры — только трафик через этот ленд, за период",
  "landers.u.none": "Ни одна живая кампания его не показывает.",
  "landers.u.none.numbers": "Цифры за период →",
  "landers.u.col.status": "Статус",
  "landers.u.col.offer": "Оффер",
  "landers.u.col.place": "Место в потоке",
  "landers.u.col.share": "Доля ленда",
  "landers.u.col.profit": "Профит",
  "landers.u.place.only": "единственный",
  "landers.u.place.share": "по долям",
  "landers.u.place.graph": "поток собран вручную",
  "landers.u.offers": "Офферы, с которыми работает",
  "landers.u.offers.none": "Офферы видны у кампаний из редактора; у собранных вручную потоков их здесь нет.",
  "landers.u.flow": "Как стоит в потоке",
  "landers.u.flow.only": "основной ленд, 100 %",
  "landers.u.flow.share": "ротация: доля {pct} из {n} лендов",
  "landers.u.flow.graph": "поток собран вручную — доля по графу потока",
  "landers.u.history": "История",
  "landers.u.h.version": "Загружена v{v}",
  "landers.u.h.current": "Загружена v{v} — показывается",
  "landers.u.h.none": "Истории пока нет",
  "landers.u.h.today": "Сегодня",
  "landers.u.h.yesterday": "Вчера",
  "landers.u.h.more": "Показать ещё",
  "landers.p.device": "Устройство",
  "landers.p.phone": "Телефон",
  "landers.p.tablet": "Планшет",
  "landers.p.desktop": "Компьютер",
  "landers.p.address": "Адрес страницы",
  "landers.p.reload": "Обновить",
  "landers.p.frame": "Просмотр ленда",
  "landers.p.checks": "Проверка",
  "landers.p.check.page": "Страница загружена — v{v}",
  "landers.p.check.page.body": "{files} файлов · пришла {at}",
  "landers.p.check.noPage": "Страница ещё не загружена",
  "landers.p.check.noPage.body": "Загрузите ZIP — без страницы ленд выпадает из ротации кампании.",
  "landers.p.check.upload": "Загрузить",
  "landers.p.check.domain": "Отдаётся на домене {fqdn}",
  "landers.p.check.domain.bound": "домен привязан к трекеру",
  "landers.p.check.domain.pending": "домен ещё привязывается",
  "landers.p.check.domain.failed": "домен не привязался — см. «Домены»",
  "landers.p.check.noDomain": "Домен не выбран",
  "landers.p.check.noDomain.body": "Ленд отдаётся на домене кампании; свой домен — в «Настройках».",
  "landers.p.check.ctas": "Кнопок, ведущих дальше: {n}",
  "landers.p.check.ctas.body": "на странице стоит {click_url} — переходы посчитаются",
  "landers.p.check.noClickUrl": "На странице нет {click_url}",
  "landers.p.check.noClickUrl.body": "Кнопки не ведут через трекер — «Пошли дальше» и LP CTR останутся пустыми.",
  "landers.p.check.inline": "Оффер прямо на странице",
  "landers.p.check.inline.body": "форма заявки без перехода — «Пошли дальше» у такого ленда не считается",
  "landers.p.macros": "Макросы на странице · {n}",
  "landers.p.macros.none": "Макросов на странице нет.",
  "landers.p.macro": "Макрос",
  "landers.p.sample": "Пример значения",
  "landers.p.from": "Откуда",
  "landers.p.from.page": "свой макрос страницы",
  "landers.p.test": "Пробная подстановка",
  "landers.p.test.run": "Проверить",
  "landers.p.test.again": "Сделать ещё раз",
  "landers.p.test.hint": "Подставим примеры значений и покажем адрес на домене — без клика, без записи в цифры.",
  "landers.p.test.macros": "Подставлено макросов: {n}",
  "landers.p.test.served": "Страница отдаётся",
  "landers.p.test.noEdge": "У ленда нет домена — адрес только внутри трекера",
  "landers.p.fireFailed": "Не удалось проверить подстановку",
  "landers.f.language.pick": "Выберите язык",
  "landers.s.notes.field": "Заметки",
};
